document.querySelectorAll('[data-email-hider]').forEach((link) => {
  const email = `${link.dataset.localPart}@${link.dataset.domain}`;

  link.textContent = email;
  link.href = `mailto:${email}`;
});
